import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MapService, MoreItem } from '@services/map';

@Component({
  templateUrl: 'map-more-popover.component.html',
  styleUrls: ['map-more-popover.component.scss']
})
export class MapMorePopoverComponent {
  get moreItems(): MoreItem[] {
    return this.mapService.moreItems;
  }

  constructor(private mapService: MapService, private popoverController: PopoverController) {}

  clickItem(item: MoreItem) {
    if (!item.keepOnClick) {
      this.popoverController.dismiss();
    }
    item.handler.call(item.context);
  }
}
